<script>
  export let x
  export let y

  export let placement = [-50, -100]

  $: side = placement[1] > -50 ? "bottom" : "top"
  $: arrowTransform = {
    top: "translate(-50%, -100%)",
    bottom: "translate(-50%, 0) rotate(180deg)",
  }[side]
</script>

<div class="wrapper" style="transform: translate({x}px, {y}px)">
  <div
    class="tooltip-wrapper"
    style="transform: translate({placement[0]}%, {placement[1]}%)"
  >
    <div class="tooltip">
      <slot />
    </div>
  </div>
  <svg class="arrow" style="transform: {arrowTransform}">
    <path d="M 0 0 L 6 6 L 12 0" fill="white" stroke="black" />
  </svg>
</div>

<style>
  .wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    pointer-events: none;
  }
  .tooltip-wrapper {
    position: absolute;
    padding: 5px;
    z-index: 1;
  }
  .arrow {
    position: absolute;
    height: 6px;
    width: 12px;
    z-index: 2;
  }
  .tooltip {
    padding: 0.5em;
    background: white;
    opacity: 0.9;
    min-width: 8em;
    text-align: center;
    font-size: 0.8rem;
    border: 1px solid rgba(88, 88, 88, 0.81);
    box-shadow: rgba(117, 117, 117, 0.15) 2.5px 2.5px 3.2px;
    background-color: #ffffff;
  }
</style>
